/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investorTypeRowDtoSchema = z.object({
  type: z.optional(z.string()),
  count: z.optional(z.string()),
  isTarget: z.optional(z.boolean()),
});
